import styled from "styled-components";

export const TextareaStyled = styled.textarea`
  width: 100%;
`;
